import React from "react";

import styles from "./OrderCloseForm.module.scss";

import { useFormContext } from "react-hook-form";
import { ICloseFormInput } from "../../types/order";

type Props = {
  index: number;
  unit_id: number;
};

const OrderCloseForm = ({ index, unit_id }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ICloseFormInput>();

  return (
    <div className={styles.OrderCloseForm}>
      <div className="mt-6">
        <label className="text-primary-1 font-bold">
          ડિલિવર કરેલ {unit_id === 3 ? "જોડી" : unit_id === 2 ? "નંગ" : "વજન"} :
        </label>
        <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 w-full relative rounded">
          <input
            className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
            type="number"
            pattern="[0-9]+(\.[0-9]+)?"
            step="any"
            placeholder={`ડિલિવર કરેલ ${
              unit_id === 3 ? "જોડી" : unit_id === 2 ? "નંગ" : "વજન"
            } દાખલ કરો`}
            {...register(`orders.${index}.delivered_qty`, {
              required: true,
            })}
            onFocus={(e) =>
              e.target.addEventListener(
                "wheel",
                function (e) {
                  e.preventDefault();
                },
                { passive: false }
              )
            }
          />
        </div>
        {errors?.orders?.[index]?.delivered_qty && (
          <span className="text-red-500">
            ડિલિવર કરેલ {unit_id === 3 ? "જોડી" : unit_id === 2 ? "નંગ" : "વજન"}{" "}
            દાખલ કરો
          </span>
        )}

        {unit_id > 1 && (
          <>
            <div className="mt-4"></div>
            <label className="text-primary-1 font-bold">
              ડિલિવર કરેલ વજન :
            </label>
            <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 w-full relative rounded">
              <input
                className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                type="number"
                pattern="[0-9]+(\.[0-9]+)?"
                step="any"
                placeholder="ડિલિવર કરેલ વજન દાખલ કરો"
                {...register(`orders.${index}.delivered_weight`, {
                  required: true,
                })}
                onFocus={(e) =>
                  e.target.addEventListener(
                    "wheel",
                    function (e) {
                      e.preventDefault();
                    },
                    { passive: false }
                  )
                }
              />
            </div>
            {errors?.orders?.[index]?.delivered_weight && (
              <span className="text-red-500">ડિલિવર કરેલ વજન દાખલ કરો</span>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default OrderCloseForm;
